import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { MobileMenu } from "../MobileMenu/MobileMenu.js";
import logo from "../../assets/elevatespacelogo.png";
import { navbarRoutes } from "../constant.js";

import "./Navbar.css";

const Navbar = () => {
    const { pathname } = useLocation();
    const [ showBg, setShowBg ] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setShowBg(window.scrollY > 120); // 👈 adjust scroll trigger here
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return (
        <nav className={`navbar ${showBg ? "navbar-bg" : ""}`}>
            <MobileMenu />
            <div className="logo">
                <img className="logo-img" src={logo} alt="Elevate Space" />
            </div>
            <ul className="nav-links">
                {navbarRoutes.map((route) => <li 
                    className={pathname === route.path ? 'matched-route' : ''}>
                        <Link to={route.path}>{route.label}</Link>
                    </li>)}
            </ul>
        </nav>
    )
};

export { Navbar };